import React, { useState } from 'react';
import { BaseComponentProps, WithClassname } from '../../types';
import { CopyOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';

type Props = BaseComponentProps &
  WithClassname & {
    value?: string;
    noIcon?: boolean;
    reverted?: boolean;
  };

export default function ClickToCopy({ value, noIcon, reverted, children, className }: Props) {
  const [clicked, setClicked] = useState(false);

  const onClick = () => {
    navigator.clipboard.writeText(value ?? children);
    setClicked(true);
  };

  return (
    <Tooltip title={clicked ? 'Copied!' : 'Click to copy'} className={className}>
      <span onClick={onClick} className="cursor-pointer">
        {reverted ? (
          <>
            {children} {!noIcon && <CopyOutlined />}
          </>
        ) : (
          <>
            {!noIcon && <CopyOutlined />} {children}
          </>
        )}
      </span>
    </Tooltip>
  );
}
